import { DateTime } from 'luxon';
import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';
import { ActType } from 'shell/constants/act-type';
// import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { idActRegex } from 'shell/constants/regex';
import { DocumentDigital } from 'shell/view-models/act-form';
import * as yup from 'yup';

export const validationSchema = yup
  .object()
  .shape({
    editDataControl: yup.object().shape({
      dateValidity: yup.date().nullable().nullable().required('campo obbligatorio'),
    }),
    civilStatus: yup.object().shape({
      status: yup.string().required('campo obbligatorio'),
    }),
    cancelMarriage: yup.object().shape({
      type: yup.string().required('campo obbligatorio'),
      dateJudgment: yup.date().nullable(),
      dateValidity: yup.date().nullable(),
      authority: yup.string().nullable(),
      courtType: yup.string().nullable(),
      isForeign: yup.boolean().nullable().notRequired(),
      // municipality: yup
      //   .object()
      //   .nullable()
      //   .shape({
      //     description: yup
      //       .string()
      //       .nullable()
      //       .when('isForeign', (isForeign, formvalidationSchema) =>
      //         isForeign
      //           ? formvalidationSchema.notRequired()
      //           : formvalidationSchema.required('campo obbligatorio')
      //       ),
      //   }),
      // foreignMunicipality: yup.object().nullable().shape({
      //   description: yup.string().nullable(),
      // }),
      actType: yup.string(),
      digital: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoDigitale,
          otherwise: yup.object().nullable(),
          then: yup
            .object()
            .nullable()
            .shape({
              idAnsc: yup
                .string()
                .nullable()
                .matches(idActRegex, 'Formato non corretto')
                .test((value) => {
                  if (value) {
                    const [year] = value.split('-');
                    const isValid = year ? Number.parseInt(year) >= 2022 : true;

                    return isValid
                      ? true
                      : new yup.ValidationError(
                          "L'idAnsc deve avere anno maggiore al 2022",
                          undefined,
                          'cancelMarriage.digital.idAnsc'
                        );
                  }
                  return true;
                })
                .required('Campo richiesto'),
              documentDate: yup
                .date()
                .nullable()
                .notRequired()
                .typeError('Formato non valido')
                .required('Campo richiesto'),
              // municipality: yup.object().shape({}).nullable().required('Campo richiesto'),
            })
            .test((values) => {
              const castedValues = values as unknown as DocumentDigital;

              if (
                castedValues?.municipality?.id &&
                castedValues?.istatCode &&
                castedValues?.municipality?.id === castedValues.istatCode
              ) {
                return true;
              }
              return new yup.ValidationError([
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'cancelMarriage.digital.municipality'
                ),
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'cancelMarriage.digital.istatCode'
                ),
              ]);
            }),
        }),
      paper: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoCartaceo,
          otherwise: yup.object().nullable(),
          then: yup.object().shape({
            actDate: yup
              .date()
              .nullable()
              .max(
                DateTime.local().plus({ days: 1 }),
                'La data non può essere successiva alla data odierna'
              )
              .typeError('Data non valida'),
            transcribed: yup.string().nullable(),
            actMunicipality: yup.object().nullable().shape({}).required('Il campo è richiesto'),
            actYear: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actNumber: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actPart: yup
              .string()
              .nullable()
              .required('Campo richiesto')
              .test(
                'part-ammisible-values',
                'Gli unici valori ammessi sono 1 o 2',
                (value) => ['1', '2'].indexOf(value || '') >= 0
              ),
            actSeries: yup.string().nullable(),
            actVolume: yup
              .string()
              .nullable()
              .when('actMunicipality.description', {
                is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
                then: yup
                  .string()
                  // .required('Campo obbligatorio')
                  .matches(/^R[0-9]{2}$/, {
                    message:
                      'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
                  }),
              }),
          }),
        }),
    }),
  })
  // controlli ATTO se presente un valore tutto l'oggetto è obbligatorio
  .test('cancelMarriage.dateAct', 'Controllo validità', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const errors = [];

    // Controlli su atto cartaceo cessazione matrimonio
    if (castedValues.cancelMarriage?.actType === ActType.AttoCartaceo) {
      // controllo data minore uguale data odierna
      if (
        castedValues.cancelMarriage?.paper?.actDate &&
        castedValues.cancelMarriage?.paper?.actDate > DateTime.now()
      ) {
        errors.push(
          new yup.ValidationError(
            'La data deve essere minore uguale della Data odierna',
            undefined,
            'cancelMarriage.paper.actDate'
          )
        );
      }

      const allValuesExectpMunicipality = Boolean(
        castedValues.cancelMarriage?.paper?.actYear ||
          castedValues.cancelMarriage?.paper?.actNumber ||
          castedValues.cancelMarriage?.paper?.actPart ||
          castedValues.cancelMarriage?.paper?.actSeries ||
          castedValues.cancelMarriage?.paper?.actVolume ||
          castedValues.cancelMarriage?.paper?.actDate ||
          castedValues.cancelMarriage?.paper?.transcribed
      );
      // controllo comune se sono popolati tutti gli altri campi
      if (
        allValuesExectpMunicipality &&
        !castedValues.cancelMarriage?.paper?.actMunicipality?.description
      ) {
        errors.push(
          new yup.ValidationError(
            'Campo obbligatorio',
            undefined,
            'cancelMarriage.paper.actMunicipality'
          )
        );
      }

      const allValuesExceptActNumber = Boolean(
        castedValues.cancelMarriage?.paper?.actYear ||
          castedValues.cancelMarriage?.paper?.actPart ||
          castedValues.cancelMarriage?.paper?.actSeries ||
          castedValues.cancelMarriage?.paper?.actVolume ||
          castedValues.cancelMarriage?.paper?.actDate ||
          castedValues.cancelMarriage?.paper?.transcribed ||
          castedValues.cancelMarriage?.paper?.actMunicipality?.description
      );
      // controllo numero atto se tutti gli altri campi sono popolati
      if (allValuesExceptActNumber && !castedValues.cancelMarriage?.paper?.actNumber) {
        errors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'cancelMarriage.paper.actNumber')
        );
      }

      const allValuesExceptActYear = Boolean(
        castedValues.cancelMarriage?.paper?.actNumber ||
          castedValues.cancelMarriage?.paper?.actPart ||
          castedValues.cancelMarriage?.paper?.actSeries ||
          castedValues.cancelMarriage?.paper?.actVolume ||
          castedValues.cancelMarriage?.paper?.actDate ||
          castedValues.cancelMarriage?.paper?.transcribed ||
          castedValues.cancelMarriage?.paper?.actMunicipality?.description
      );
      // controllo anno se tutti gli altri sono presenti
      if (allValuesExceptActYear && !castedValues.cancelMarriage?.paper?.actYear) {
        errors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'cancelMarriage.paper.actYear')
        );
      }

      const isPresentOtherValues = Boolean(
        castedValues.cancelMarriage?.paper?.actNumber ||
          castedValues.cancelMarriage?.paper?.actYear ||
          castedValues.cancelMarriage?.paper?.actSeries ||
          castedValues.cancelMarriage?.paper?.actVolume ||
          castedValues.cancelMarriage?.paper?.actDate ||
          castedValues.cancelMarriage?.paper?.transcribed ||
          castedValues.cancelMarriage?.paper?.actMunicipality?.description
      );
      // controllo parte se tutti gli altri presenti
      if (isPresentOtherValues && !castedValues.cancelMarriage?.paper?.actPart) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'cancelMarriage.paper.actPart'
        );
      }
    }

    if (errors.length > 0) {
      return new yup.ValidationError(errors);
    }

    return false;
  })
  // controlli SENTENZA se presente un valore tutto l'oggetto è obbligatorio
  .test('cancelMarriage.foreignMunicipality', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValues = Boolean(
      castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment
    );
    // controllo data comune estero
    if (
      isPresentOtherValues &&
      castedValues.cancelMarriage?.isForeign &&
      !castedValues.cancelMarriage?.foreignMunicipality?.description
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'cancelMarriage.foreignMunicipality'
      );
    }

    return false;
  })
  // .test('cancelMarriage.municipality', 'Campo obbligatorio', (values) => {
  //   const castedValues = values as unknown as CancelMarriageFormVM;

  //   const isPresentOtherValues = Boolean(
  //     castedValues.cancelMarriage?.dateValidity ||
  //       castedValues.cancelMarriage?.authority ||
  //       castedValues.cancelMarriage?.courtType ||
  //       castedValues.cancelMarriage?.number ||
  //       castedValues.cancelMarriage?.dateJudgment
  //   );
  //   // controllo data comune estero
  //   if (
  //     isPresentOtherValues &&
  //     !castedValues.cancelMarriage?.isForeign &&
  //     !castedValues.cancelMarriage?.municipality
  //   ) {
  //     return new yup.ValidationError(
  //       'Campo obbligatorio',
  //       undefined,
  //       'cancelMarriage.municipality'
  //     );
  //   }

  //   return false;
  // })
  .test('cancelMarriage.dateJudgment', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValues = Boolean(
      castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment
    );
    // controllo data sentenza
    if (isPresentOtherValues && !castedValues.cancelMarriage?.dateJudgment) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'cancelMarriage.dateJudgment'
      );
    }

    if (
      isPresentOtherValues &&
      castedValues.cancelMarriage?.dateJudgment &&
      castedValues.editDataControl?.dateValidity &&
      castedValues.cancelMarriage?.dateJudgment > castedValues.editDataControl?.dateValidity
    ) {
      return new yup.ValidationError(
        'La data deve essere minore uguale della Data decorrenza',
        undefined,
        'cancelMarriage.dateJudgment'
      );
    }

    return false;
  })
  .test('cancelMarriage.dateValidity', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValues = Boolean(
      castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.authority
    );
    // controllo data validità
    if (isPresentOtherValues && !castedValues.cancelMarriage?.dateValidity) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'cancelMarriage.dateValidity'
      );
    }

    if (
      isPresentOtherValues &&
      castedValues.cancelMarriage?.dateValidity &&
      castedValues.editDataControl?.dateValidity &&
      castedValues.cancelMarriage?.dateValidity > castedValues.editDataControl?.dateValidity
    ) {
      return new yup.ValidationError(
        'La data deve essere minore uguale della Data decorrenza',
        undefined,
        'cancelMarriage.dateValidity'
      );
    }

    return false;
  })
  .test('cancelMarriage.authority', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValues = Boolean(
      castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.authority
    );
    // controllo autorità
    if (isPresentOtherValues && !castedValues.cancelMarriage?.authority) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'cancelMarriage.authority');
    }

    return false;
  })
  .test('cancelMarriage.courtType', 'Campo obbligatorio', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValues = Boolean(
      castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment
    );
    // controllo tipo tribunale
    if (isPresentOtherValues && !castedValues.cancelMarriage?.courtType) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'cancelMarriage.courtType');
    }

    return false;
  })
  // controlli deve essere presente almeno un oggetto tra ATTO e SENTENZA
  .test('cancelMarriage.year', 'Inserire valori Atto o valori Sentenza', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValuesJudgment = Boolean(
      castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment
    );

    const isPresentOtherValuesAct = Boolean(
      castedValues.cancelMarriage?.paper?.actYear ||
        castedValues.cancelMarriage?.paper?.actNumber ||
        castedValues.cancelMarriage?.paper?.actPart ||
        castedValues.cancelMarriage?.paper?.actMunicipality?.description ||
        castedValues.cancelMarriage?.paper?.actSeries ||
        castedValues.cancelMarriage?.paper?.actVolume ||
        castedValues.cancelMarriage?.paper?.actDate ||
        castedValues.cancelMarriage?.paper?.transcribed
    );

    // controllo per sentenza
    if (
      !isPresentOtherValuesJudgment &&
      !isPresentOtherValuesAct &&
      castedValues.cancelMarriage?.actType === ActType.AttoCartaceo
    ) {
      return new yup.ValidationError(
        'Inserire valori Atto o valori Sentenza',
        undefined,
        'cancelMarriage.year'
      );
    }

    return false;
  })
  .test('cancelMarriage.dateJudgment', 'Inserire valori Atto o valori Sentenza', (values) => {
    const castedValues = values as unknown as CancelMarriageFormVM;

    const isPresentOtherValuesAct = Boolean(
      castedValues.cancelMarriage?.paper?.actYear ||
        castedValues.cancelMarriage?.paper?.actNumber ||
        castedValues.cancelMarriage?.paper?.actPart ||
        castedValues.cancelMarriage?.paper?.actMunicipality?.description ||
        castedValues.cancelMarriage?.paper?.actSeries ||
        castedValues.cancelMarriage?.paper?.actVolume ||
        castedValues.cancelMarriage?.paper?.actDate ||
        castedValues.cancelMarriage?.paper?.transcribed
    );

    const isPresentOtherValuesJudgment = Boolean(
      castedValues.cancelMarriage?.dateJudgment ||
        castedValues.cancelMarriage?.dateValidity ||
        castedValues.cancelMarriage?.authority ||
        castedValues.cancelMarriage?.courtType ||
        castedValues.cancelMarriage?.number ||
        castedValues.cancelMarriage?.dateJudgment
    );

    // controllo atto
    if (
      !isPresentOtherValuesAct &&
      !isPresentOtherValuesJudgment &&
      castedValues.cancelMarriage?.actType === ActType.AttoCartaceo
    ) {
      return new yup.ValidationError(
        'Inserire valori Atto o valori Sentenza',
        undefined,
        'cancelMarriage.dateJudgment'
      );
    }

    return false;
  });
